package org.vreo.devicehub.features.vrmOutput.domain.models

/**
 * Vrm overlayer position
 *
 * @constructor Create empty Vrm overlayer position
 */
enum class VrmOverlayerPosition {
    TOP_LEFT,
    TOP_RIGHT,
    BOTTOM_LEFT,
    BOTTOM_RIGHT
}